/**
 * Awvent - Business Accounts API
 * Awvent Accounts Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddressDto } from '../../../../shared/common/models/addressDto';
import { ContactCompactDto } from '../../../../shared/common/models/contactCompactDto';
import { EmailAddressDto } from '../../../../shared/common/models/emailAddressDto';
import { MobileNumberDto } from '../../../../shared/common/models/mobileNumberDto';
import { PhoneNumberDto } from '../../../../shared/common/models/phoneNumberDto';
import { WebsiteAddressDto } from '../../../../shared/common/models/websiteAddressDto';

export class BusinessAccountDto {
    id?: string;
    tenantId?: string;
    code?: string;
    name?: string;
    contacts?: Array<ContactCompactDto>;
    isActive?: boolean;
    registeredDate?: Date;
    opportunities?: string[];
    addresses?: Array<AddressDto>;
    emails?: Array<EmailAddressDto>;
    phoneNumbers?: Array<PhoneNumberDto>;
    mobileNumbers?: Array<MobileNumberDto>;
    websites?: Array<WebsiteAddressDto>;
    createdTime?: Date;
    createdBy?: string;
}
